import ThemeContext from "./ThemeContext";
import getDefaultTheme from "./getDefaultTheme";
import isEmptyObject from "@suid/utils/isEmptyObject";
import { useContext } from "solid-js";
function useTheme(defaultTheme = getDefaultTheme, Context = ThemeContext) {
    const theme = useContext(Context);
    if (isEmptyObject(theme) && defaultTheme) {
        if (typeof defaultTheme === "function")
            return defaultTheme();
        return defaultTheme;
    }
    if (!theme)
        throw new Error("Theme is not defined");
    return theme;
}
export default useTheme;
